import { defineMessages } from 'react-intl';

export default function initCuisines() {
  defineMessages({
    cuisine_african: {
      id: 'cuisine.African',
      defaultMessage: 'African',
    },
    cuisine_american: {
      id: 'cuisine.American',
      defaultMessage: 'American',
    },
    cuisine_arabian: {
      id: 'cuisine.Arabian',
      defaultMessage: 'Arabian',
    },
    cuisine_asian: {
      id: 'cuisine.Asian',
      defaultMessage: 'Asian',
    },
    cuisine_czech: {
      id: 'cuisine.Czech',
      defaultMessage: 'Czech',
    },
    cuisine_chinese: {
      id: 'cuisine.Chinese',
      defaultMessage: 'Chinese',
    },
    cuisine_european: {
      id: 'cuisine.European',
      defaultMessage: 'European',
    },
    cuisine_french: {
      id: 'cuisine.French',
      defaultMessage: 'French',
    },
    cuisine_german: {
      id: 'cuisine.German',
      defaultMessage: 'German',
    },
    cuisine_greek: {
      id: 'cuisine.Greek',
      defaultMessage: 'Greek',
    },
    cuisine_hawaiian: {
      id: 'cuisine.Hawaiian',
      defaultMessage: 'Hawaiian',
    },
    cuisine_hungarian: {
      id: 'cuisine.Hungarian',
      defaultMessage: 'Hungarian',
    },
    cuisine_indian: {
      id: 'cuisine.Indian',
      defaultMessage: 'Indian',
    },
    cuisine_italian: {
      id: 'cuisine.Italian',
      defaultMessage: 'Italian',
    },
    cuisine_japanese: {
      id: 'cuisine.Japanese',
      defaultMessage: 'Japanese',
    },
    cuisine_korean: {
      id: 'cuisine.Korean',
      defaultMessage: 'Korean',
    },
    cuisine_malaysian: {
      id: 'cuisine.Malaysian',
      defaultMessage: 'Malaysian',
    },
    cuisine_mediterranean: {
      id: 'cuisine.Mediterranean',
      defaultMessage: 'Mediterranean',
    },
    cuisine_mexican: {
      id: 'cuisine.Mexican',
      defaultMessage: 'Mexican',
    },
    cuisine_middle_east: {
      id: 'cuisine.Middle East',
      defaultMessage: 'Middle East',
    },
    cuisine_nordic: {
      id: 'cuisine.Nordic',
      defaultMessage: 'Nordic',
    },
    cuisine_serbian: {
      id: 'cuisine.Serbian',
      defaultMessage: 'Serbian',
    },
    cuisine_thai: {
      id: 'cuisine.Thai',
      defaultMessage: 'Thai',
    },
    cuisine_vietnamese: {
      id: 'cuisine.Vietnamese',
      defaultMessage: 'Vietnamese',
    },
  });
}
